import { render, staticRenderFns } from "./PageFooterV2.vue?vue&type=template&id=6e34701b"
import script from "./PageFooterV2.vue?vue&type=script&lang=js"
export * from "./PageFooterV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports